import { FC } from 'react';
import { useTranslation } from 'hooks';
import { DafStatusInformerLayout } from './components/DafStatusInformerLayout/DafStatusInformerLayout';
import Button from 'components/ui/button';
import { getCommercialOffer } from 'api/maf';
import { ReactComponent as WaitingImage } from 'images/getStarted/waiting.svg';

interface Props {
  email: string;
  needButton?: boolean;
}

export const CommercialOfferWasAccepted: FC<Props> = ({
  email,
  needButton,
}) => {
  const getTranslate = useTranslation();

  return (
    <DafStatusInformerLayout
      title={getTranslate('getStarted.offerIsAccepted.label')}
      mainText={getTranslate('getStarted.offerIsAccepted.text', {
        email: `<a href="mailto:${email}">${email}</a>`,
      })}
      buttons={
        needButton && (
          <Button
            id='comOfferDownload'
            status='outline'
            onClick={() => getCommercialOffer()}
            text={getTranslate('getStarted.downloadOffer.button')}
          />
        )
      }
      image={<WaitingImage />}
    />
  );
};
